export default __webpack_public_path__ + "static/media/thumb_bainbridge_hs.b2e5599b.jpg";